// extracted by mini-css-extract-plugin
module.exports = {"root":"RollerExamPage_root__2eYB5","subtitle":"RollerExamPage_subtitle__3xMU7","text":"RollerExamPage_text__3jl5g","links":"RollerExamPage_links__2Vhl7"};